// SEO Head — Lot 14B.
// Wrapper autour de react-helmet-async, injecte tous les tags SEO nécessaires
// et calcule canonical, robots, JSON-LD.

import { Helmet } from "react-helmet-async";
import { seoConfig } from "./seoConfig";

const SEOHead = ({
  title,
  description,
  path = "/",
  keywords = [],
  jsonLd = [],
  noindex = false,
  ogImage,
}) => {
  const canonical = `${seoConfig.siteUrl}${path}`;
  const image = ogImage || seoConfig.defaultOgImage;
  const robotsContent = noindex ? "noindex,nofollow" : "index,follow";
  const jsonLdArray = Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  return (
    <Helmet>
      <html lang="fr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(", ")} />
      )}
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={robotsContent} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={seoConfig.siteName} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD */}
      {jsonLdArray.filter(Boolean).map((data, i) => (
        <script
          key={i}
          type="application/ld+json"
          data-testid={`json-ld-${i}`}
        >
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEOHead;
